//---------------------------old one -------------------------
// import React, { useEffect, useRef, useState } from "react";
// import _ from "lodash";
// import ErrorTextHelper from "./ErrorTextHelper";
// import ReactQuill from "react-quill";
// import { Controller } from "react-hook-form";
// import "react-quill/dist/quill.snow.css";
// import { stripHTMLTags } from "../../utils/helper";
// import Quill from "quill";
// import "quill/dist/quill.snow.css";
// import "quill-mention/dist/quill.mention.css";
// // import "quill-mention";
// import "quill-mention/autoregister";
// import { getMentioned } from "../../services/feedPage.services";

// // We will explicity destruct props which are not Mui props or want to manipulates
// // "...props" will have all the props which is accepted by Mui component, e.g. variant, onChange etc...
// interface externalLabel {
//   [key: string]: any;
// }
// type Mention = { value: string; id: number };
// interface RichTextEditorProps {
//   // Primary props
//   name: string;
//   control?: any; // Must be react-hook-form control
//   externalLabel?: externalLabel;
//   validationObj?: object;
//   showError?: boolean;
//   // other props of the component which directly used in component
//   [key: string]: any;
//   showCount?: boolean;
//   maxLimit?: number;
//   counterAlign?: "left" | "center" | "right";
//   useMention?: boolean;
//   AIflag?: boolean; 
// }
// const RichTextEditor = ({
//   name,
//   control,
//   validationObj,
//   className,
//   placeholder,
//   showError = true,
//   showCount,
//   maxLimit = 1000,
//   counterAlign = "right",
//   useMention = false,
//   AIflag = false,
//   ...props
// }: RichTextEditorProps) => {
//   //  External label
//   const externalLabel = _.get(props, "externalLabel.label", "") || "";
//   let externalLabelClass = _.get(props, "externalLabel.className", "") || "";
//   const externalLabelClasses = _.chain([externalLabelClass])
//     .uniq()
//     .join(" ")
//     .split(" ")
//     .uniq()
//     .join(" ")
//     .trim()
//     .value();
//   // Error message
//   const errorMessage = _.get(validationObj, `${name}.message`, null);

//   // Use when Form Hook control is not used
//   const quillValue = props?.value || "";
//   const quillRef = useRef<any>(null);
//   const handleOnChange = (text: string) => {
//     if (typeof props?.onChange === "function") {
//       props.onChange(text);
//     }
//   };
//   // const staticHashtags = [
//   //   { id: 3, value: "world" },
//   //   { id: 4, value: "quill" },
//   // ];
//   let searchDelay: NodeJS.Timeout;
//   const [quillInstance, setQuillInstance] = useState<any>(null);
//   const fetchMentionValues = (search: string) =>
//     new Promise((resolve) => {
//       clearTimeout(searchDelay);
//       searchDelay = setTimeout(async () => {
//         const apiData: any = await getMentioned(search);
//         const responseData = _.get(apiData, "data.data", []);
//         resolve(responseData);
//         return responseData;
//       }, 1000);
//     });

//   useEffect(() => {
//     if (!quillRef.current) {
//       return; // Wait for the ref to be assigned
//     }
//     if (quillRef.current) {
//       const editor: any = new Quill(quillRef.current, {
//         theme: "snow",
//         placeholder: placeholder || "",
//         modules: {
//           mention: {
//             allowedChars: /^[A-Za-z\sÅÄÖåäö]*$/,
//             mentionDenotationChars: ["@"],
//             dataAttributes: ["disabled"],
//             showDenotationChar: true,
//             source: async (
//               searchTerm: string,
//               renderList: (items: Mention[], searchTerm: string) => void,
//               mentionChar: string
//             ) => {
//               let values: Mention[] = [];

//               if (mentionChar === "@" && searchTerm === "") {
//                 // Case 1: Call the API immediately when "@" is typed
//                 try {
//                   const data: any = await fetchMentionValues("");
//                   renderList(data, searchTerm);
//                   if (props?.setOverflow) {
//                     props?.setOverflow(true);
//                   }
//                 } catch (error) {
//                   console.error("Error fetching mention values:", error);
//                 }
//                 return;
//               }

//               if (mentionChar === "@" && searchTerm.length > 1) {
//                 // Case 2: Call the API with the typed text in the payload
//                 try {
//                   const data: any = await fetchMentionValues(searchTerm);
//                   if (props?.setOverflow) {
//                     props?.setOverflow(true);
//                   }
//                   renderList(data, searchTerm);
//                 } catch (error) {
//                   console.error("Error fetching mention values:", error);
//                 }
//                 return;
//               }

//               if (searchTerm.length === 0) {
//                 if (props?.setOverflow) {
//                   props?.setOverflow(true);
//                 }
//                 // Case 3: User has cleared the input, render an empty list
//                 renderList(values, searchTerm);
//               } else {
//                 // Case 4: Filter values based on the typed text
//                 const matches = values?.filter((item: any) =>
//                   item?.value?.toLowerCase()?.includes(searchTerm.toLowerCase())
//                 );
//                 if (props?.setOverflow) {
//                   props?.setOverflow(false);
//                 }
//                 renderList(matches, searchTerm);
//               }
//             },
//           },
//         },
//       });
//       setQuillInstance(editor);
//       const defaultValue = control.getValues(name) || "";
//       editor.root.innerHTML = defaultValue;
//       editor.on("text-change", () => {
//         const content = editor.root.innerHTML;
//         control.setValue(name, content);
//         if (props?.setOverflow) {
//           props?.setOverflow(false);
//         }
//       });
//     }
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, []);

//   useEffect(() => {
//     if (quillInstance) {
//       quillInstance.root.innerHTML = props.value;
//     }

//      // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [AIflag]);

//   return (
//     <>
//       {externalLabel && (
//         <label htmlFor={props.name} className={externalLabelClasses}>
//           {externalLabel}
//         </label>
//       )}
//       {control ? (
//         <>
//           <Controller
//             name={name}
//             rules={props.rules || {}}
//             control={control}
//             defaultValue={props.defaultValue}
//             render={({ onChange, value }: any) => (
//               <>
//                 {useMention ? (
//                   <div className="quill">
//                     <div ref={quillRef} />
//                   </div>
//                 ) : (
//                   <ReactQuill
//                     value={value || ""}
//                     placeholder={placeholder || ""}
//                     onChange={(content: any) => {
//                       const initValue = [
//                         "<p><br></p>",
//                         "<p><br></p><p><br></p>",
//                         "<h1><br></h1>",
//                         "<h2><br></h2>",
//                         "<h3><br></h3>",
//                         "<ol><li><br></li></ol>",
//                         "<ul><li><br></li></ul>",
//                       ];

//                       // Check if content starts with any of the initial values
//                       const startsWithInitValue = initValue.some(
//                         (value) => value.trim() === content.trim()
//                       );

//                       if (startsWithInitValue) {
//                         onChange("");
//                       } else {
//                         onChange(content);
//                       }
//                     }}
//                   />
//                 )}
//                 {showCount && (
//                   <p
//                     className={`${className} mt-2 global-counter ${
//                       (counterAlign === "center" || counterAlign === "right") &&
//                       `align-${counterAlign}`
//                     } ${
//                       stripHTMLTags(value).length > maxLimit && "error-text"
//                     }`}
//                   >
//                     {`${stripHTMLTags(value).length}/${maxLimit}`}
//                   </p>
//                 )}
//               </>
//             )}
//           />
//           {errorMessage && showError && <ErrorTextHelper text={errorMessage} />}
//         </>
//       ) : (
//         <ReactQuill
//           value={quillValue || ""}
//           placeholder={placeholder || ""}
//           onChange={(content: any) => {
//             const initValue = [
//               "<p><br></p>",
//               "<h1><br></h1>",
//               "<h2><br></h2>",
//               "<h3><br></h3>",
//               "<ol><li><br></li></ol>",
//               "<ul><li><br></li></ul>",
//             ].filter((char) => content.indexOf(char) === 0);
//             // Check if blank value is added
//             if (initValue.length > 0) {
//               handleOnChange("");
//             } else {
//               handleOnChange(content);
//             }
//           }}
//         />
//       )}
//     </>
//   );
// };
// export default RichTextEditor;


//without new option work 

import React, { useEffect, useRef, useState } from "react";
import _ from "lodash";
import ErrorTextHelper from "./ErrorTextHelper";
import ReactQuill from "react-quill";
import { Controller } from "react-hook-form";
import "react-quill/dist/quill.snow.css";
import { stripHTMLTags } from "../../utils/helper";
import Quill from "quill";
import "quill/dist/quill.snow.css";
import "quill-mention/dist/quill.mention.css";
import "quill-mention/autoregister";
import { getMentioned } from "../../services/feedPage.services";
import articleEditorIcons from "./ArticleTextEditor.icons";
import QuillLinkDialog, {
  bindQuillLinkDialog,
  LinkDialogPayload,
} from "./QuillLinkDialog";
import { SnowTheme as EnhancedSnowTheme } from "quill-color-picker-enhance";
import "quill-color-picker-enhance/dist/index.css";
import {
  RICH_TEXT_FORMATS,
  RICH_TEXT_TOOLBAR,
} from "./richTextToolbar";

export const RICH_TEXT_EDITOR_WRAPPER_CLASS = "rich-text-editor";
export const RICH_TEXT_EDITOR_THEME = "snow-quill-color-picker-enhance";

const QuillInstance = (ReactQuill as any).Quill || Quill;
QuillInstance.register("themes/snow-quill-color-picker-enhance", EnhancedSnowTheme);
Quill.register("themes/snow-quill-color-picker-enhance", EnhancedSnowTheme);

const QuillIcons = Quill.import("ui/icons") as Record<string, any>;
QuillIcons.bold = articleEditorIcons.bold;
QuillIcons.italic = articleEditorIcons.italic;
QuillIcons.underline = articleEditorIcons.underline;
QuillIcons.strike = articleEditorIcons.strike;
QuillIcons.list = articleEditorIcons.list;
QuillIcons.link = articleEditorIcons.link;
QuillIcons.image = articleEditorIcons.image;

const EDITOR_MODULES = { toolbar: RICH_TEXT_TOOLBAR };

interface ExternalLabel {
  label?: string;
  className?: string;
  [key: string]: any;
}

type Mention = {
  value: string;
  id: number;
};

interface RichTextEditorProps {
  name: string;
  control?: any;
  externalLabel?: ExternalLabel;
  validationObj?: object;
  showError?: boolean;
  className?: string;
  placeholder?: string;
  showCount?: boolean;
  maxLimit?: number;
  counterAlign?: "left" | "center" | "right";
  useMention?: boolean;
  AIflag?: boolean;
  value?: string;
  onChange?: (value: string) => void;
  setOverflow?: (overflow: boolean) => void;
  rules?: object;
  defaultValue?: string;
  [key: string]: any;
}

const StyledReactQuill: React.FC<React.ComponentProps<typeof ReactQuill>> = (
  props
) => {
  const quillRef = useRef<any>(null);
  const [linkDialog, setLinkDialog] = useState<LinkDialogPayload | null>(null);

  useEffect(() => {
    const quill = quillRef.current?.getEditor();
    if (!quill) return;
    return bindQuillLinkDialog(quill as any, setLinkDialog);
  }, []);

  return (
    <>
      <ReactQuill
        {...props}
        ref={quillRef}
        theme={RICH_TEXT_EDITOR_THEME}
        modules={EDITOR_MODULES}
        formats={RICH_TEXT_FORMATS}
      />
      <QuillLinkDialog
        payload={linkDialog}
        onClose={() => setLinkDialog(null)}
      />
    </>
  );
};

const EditorMeta: React.FC<{
  errorMessage?: string | null;
  showError: boolean;
  showCount: boolean;
  count: number;
  maxLimit: number;
}> = ({ errorMessage, showError, showCount, count, maxLimit }) => {
  if ((!errorMessage || !showError) && !showCount) {
    return null;
  }

  return (
    <div className="rich-text-editor__footer">
      <div className="rich-text-editor__error">
        {errorMessage && showError ? (
          <ErrorTextHelper text={errorMessage} />
        ) : null}
      </div>
      {showCount && (
        <p
          className={`rich-text-editor__counter${count > maxLimit ? " is-error" : ""
            }`}
        >
          {`${count}/${maxLimit}`}
        </p>
      )}
    </div>
  );
};

// Separate component for Quill mention editor
const QuillMentionField: React.FC<{
  name: string;
  field: any;
  placeholder: string;
  setOverflow?: (overflow: boolean) => void;
  AIflag?: boolean;
  externalValue?: string;
}> = ({ name, field, placeholder, setOverflow, AIflag, externalValue }) => {
  const editorRef = useRef<HTMLDivElement>(null);
  const quillRef = useRef<any>(null);
  const fieldRef = useRef(field);
  const suppressChangeRef = useRef(false);
  const [linkDialog, setLinkDialog] = useState<LinkDialogPayload | null>(null);
  let searchDelay: NodeJS.Timeout;

  // Update field ref
  fieldRef.current = field;

  const fetchMentionValues = (search: string): Promise<Mention[]> =>
    new Promise((resolve) => {
      clearTimeout(searchDelay);
      searchDelay = setTimeout(async () => {
        try {
          const apiData: any = await getMentioned(search);
          const responseData = _.get(apiData, "data.data", []);
          resolve(responseData);
        } catch (error) {
          console.error("Error fetching mention values:", error);
          resolve([]);
        }
      }, 1000);
    });

  // Initialize Quill only once
  useEffect(() => {
    if (!editorRef.current || quillRef.current) return;

    const quill = new Quill(editorRef.current, {
      theme: RICH_TEXT_EDITOR_THEME,
      placeholder: placeholder,
      modules: {
        toolbar: RICH_TEXT_TOOLBAR,
        mention: {
          allowedChars: /^[A-Za-z\sÅÄÖåäö]*$/,
          mentionDenotationChars: ["@"],
          dataAttributes: ["disabled"],
          showDenotationChar: true,
          positioningStrategy: "fixed",
          source: async (
            searchTerm: string,
            renderList: (items: Mention[], searchTerm: string) => void,
            mentionChar: string
          ) => {
            let values: Mention[] = [];
            if (mentionChar === "@" && searchTerm === "") {
              try {
                const data = await fetchMentionValues("");
                renderList(data, searchTerm);
                setOverflow?.(true);
              } catch (error) {
                console.error("Error fetching mention values:", error);
              }
              return;
            }

            if (mentionChar === "@" && searchTerm.length > 0) {
              try {
                const data = await fetchMentionValues(searchTerm);
                renderList(data, searchTerm);
                setOverflow?.(true);
              } catch (error) {
                console.error("Error fetching mention values:", error);
              }
              return;
            }

            if (searchTerm.length === 0) {
              setOverflow?.(true);
              renderList(values, searchTerm);
            } else {
              const matches = values.filter((item: Mention) =>
                item.value.toLowerCase().includes(searchTerm.toLowerCase())
              );
              setOverflow?.(false);
              renderList(matches, searchTerm);
            }
          },
        },
      },
    });

    quillRef.current = quill;
    quill.root.setAttribute("autocapitalize", "off");
    quill.root.setAttribute("autocorrect", "off");

    // Set initial value
    if (fieldRef.current.value && fieldRef.current.value !== "<p><br></p>") {
      suppressChangeRef.current = true;
      quill.clipboard.dangerouslyPasteHTML(fieldRef.current.value);
      suppressChangeRef.current = false;
    }

    // Handle text changes - use requestAnimationFrame to batch updates
    const handleTextChange = () => {
      if (suppressChangeRef.current) return;

      requestAnimationFrame(() => {
        const html = quill.root.innerHTML;
        if (fieldRef.current) {
          fieldRef.current.onChange(html);
        }
        setOverflow?.(false);
      });
    };

    quill.on("text-change", handleTextChange);
    const unbindLink = bindQuillLinkDialog(quill as any, setLinkDialog);

    return () => {
      unbindLink();
      if (quillRef.current) {
        quillRef.current.off("text-change", handleTextChange);
        quillRef.current = null;
      }
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [placeholder]);

  // Update on AIflag change
  useEffect(() => {
    if (quillRef.current && AIflag && externalValue !== undefined) {
      suppressChangeRef.current = true;
      quillRef.current.clipboard.dangerouslyPasteHTML(externalValue);
      suppressChangeRef.current = false;
    }
  }, [AIflag, externalValue]);

  return (
    <div className="quill">
      <div ref={editorRef} />
      <QuillLinkDialog
        payload={linkDialog}
        onClose={() => setLinkDialog(null)}
      />
    </div>
  );
};

const RichTextEditor: React.FC<RichTextEditorProps> = ({
  name,
  control,
  validationObj,
  className = "",
  placeholder = "Start writing...",
  showError = true,
  showCount = true,
  maxLimit = 1000,
  useMention = false,
  AIflag = false,
  externalLabel,
  ...props
}) => {
  const labelText = externalLabel?.label || "";
  const labelClassName = externalLabel?.className || "";
  const externalLabelClasses = _.chain([labelClassName])
    .uniq()
    .join(" ")
    .split(" ")
    .uniq()
    .join(" ")
    .trim()
    .value();

  const errorMessage = _.get(validationObj, `${name}.message`, null);

  const isEmptyContent = (content: string): boolean => {
    const initValues = [
      "<p><br></p>",
      "<p><br></p><p><br></p>",
      "<h1><br></h1>",
      "<h2><br></h2>",
      "<h3><br></h3>",
      "<ol><li><br></li></ol>",
      "<ul><li><br></li></ul>",
    ];
    return initValues.some(val => val.trim() === content.trim());
  };

  const handleOnChange = (content: string) => {
    if (typeof props.onChange === "function") {
      props.onChange(content);
    }
  };

  const renderEditor = () => {
    if (control) {
      return (
        <Controller
          name={name}
          control={control}
          rules={props.rules || {}}
          defaultValue={props.defaultValue || ""}
          render={({ field }) => (
            <>
              {useMention ? (
                <QuillMentionField
                  key={name}
                  name={name}
                  field={field}
                  placeholder={placeholder}
                  setOverflow={props.setOverflow}
                  AIflag={AIflag}
                  externalValue={props.value}
                />
              ) : (
                <StyledReactQuill
                  className={className}
                  value={field.value || ""}
                  placeholder={placeholder}
                  onChange={(content: string) => {
                    if (isEmptyContent(content)) {
                      field.onChange("");
                    } else {
                      field.onChange(content);
                    }
                  }}
                />
              )}
              <EditorMeta
                errorMessage={errorMessage}
                showError={showError}
                showCount={showCount}
                count={stripHTMLTags(field.value || "").length}
                maxLimit={maxLimit}
              />
            </>
          )}
        />
      );
    }

    return (
      <>
        <StyledReactQuill
          className={className}
          value={props.value || ""}
          placeholder={placeholder}
          onChange={(content: string) => {
            if (isEmptyContent(content)) {
              handleOnChange("");
            } else {
              handleOnChange(content);
            }
          }}
        />
        <EditorMeta
          errorMessage={errorMessage}
          showError={showError}
          showCount={showCount}
          count={stripHTMLTags(props.value || "").length}
          maxLimit={maxLimit}
        />
      </>
    );
  };

  const hasError = Boolean(errorMessage && showError);

  return (
    <>
      {labelText && (
        <label htmlFor={name} className={externalLabelClasses}>
          {labelText}
        </label>
      )}

      <div
        className={[
          RICH_TEXT_EDITOR_WRAPPER_CLASS,
          hasError ? "is-error" : "",
          className,
        ]
          .filter(Boolean)
          .join(" ")}
      >
        {renderEditor()}
      </div>
    </>
  );
};

export default RichTextEditor;
